module.exports = __webpack_public_path__ + "img/hdc_03.c1a40836.png";